import { render, staticRenderFns } from "./ui-banner.vue?vue&type=template&id=7353544f&scoped=true"
import script from "./ui-banner.vue?vue&type=script&lang=js"
export * from "./ui-banner.vue?vue&type=script&lang=js"
import style0 from "./ui-banner.vue?vue&type=style&index=0&id=7353544f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7353544f",
  null
  
)

export default component.exports